import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";

const UpdatePassword = () => {
    const [passwords, setPasswords] = useState({
        current_password: "",
        new_password: "",
        new_password_confirmation: "",
    });

    // We don't need a separate state for local non-API errors if we use toast for everything
    // const [error, setError] = useState(""); 

    // Handle input change
    const handleChange = (e) => {
        setPasswords({ ...passwords, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        const id = toast.loading("Updating password...");

        // Local check for password match (redundant since Laravel checks, but good for quick UX)
        if (passwords.new_password !== passwords.new_password_confirmation) {
            toast.error("New password and confirm password do not match!", { id });
            // Clear passwords except for the confirmation, which is also cleared below
            // setPasswords({ current_password: "", new_password: "", new_password_confirmation: "" }); // Optional: clear inputs
            return;
        }

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://admin.tulikaarts.in/api/update-password',
            headers: {
                'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
            },
            data: passwords
        };

        axios.request(config)
            .then((response) => {
                // Check for custom status from the API (status: true)
                if (response.data.status === true) {
                    toast.success(response.data.message, { id });
                } else {
                    // Fallback success handling
                    toast.success("Password updated successfully!", { id });
                }
            })
            .catch((error) => {
                const responseData = error.response?.data;

                if (error.response?.status === 422 && responseData?.errors) {
                    // 1. Handle Laravel Validation Errors (Status 422)
                    let errorMessages = [];
                    // Flatten all error messages into a single array
                    Object.values(responseData.errors).forEach(messages => {
                        errorMessages.push(...messages);
                    });
                    
                    // Display all errors via toast
                    errorMessages.forEach(msg => toast.error(msg, { id: 'temp' }));
                    toast.dismiss(id); // Dismiss loading toast
                    
                } else if (responseData?.message) {
                    // 2. Handle specific API business logic errors (e.g., Status 403: "Current password is incorrect.")
                    toast.error(responseData.message, { id });
                } else {
                    // 3. Handle network or unknown errors
                    toast.error("An unexpected error occurred. Please try again.", { id });
                }
            })
            .finally(() => {
                 // Clear inputs regardless of success or failure
                setPasswords({ current_password: "", new_password: "", new_password_confirmation: "" });
            });
    };

    return (
        <div className="container " style={{ marginTop: "100px" }}>
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card p-4 shadow-sm">
                        <h2 className="text-center mb-4">🔑 Update Password</h2>

                        {/* Removed local error display as toast handles all messages */}

                        <form onSubmit={handleSubmit}>
                            {/* Old Password */}
                            <div className="mb-3">
                                <label className="form-label">Old Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    name="current_password"
                                    value={passwords.current_password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {/* New Password */}
                            <div className="mb-3">
                                <label className="form-label">New Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    name="new_password"
                                    value={passwords.new_password}
                                    onChange={handleChange}
                                    required
                                    minLength={8} // Added HTML validation for better UX
                                />
                            </div>

                            {/* Confirm New Password */}
                            <div className="mb-4">
                                <label className="form-label">Confirm New Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    name="new_password_confirmation"
                                    value={passwords.new_password_confirmation}
                                    onChange={handleChange}
                                    required
                                    minLength={8}
                                />
                            </div>

                            {/* Submit Button */}
                            <button type="submit" className="btn btn-dark w-100 py-2 rounded-pill">
                                Update Password
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdatePassword;